
import { compare, Lazy } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { empty } from "../fable_modules/fable-library-js.5.13.0/Set.js";
import { defaultArg } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { CursorType_$reflection, Connection_$reflection, Memory1_$reflection, HighLightColor_$reflection, ComponentType_$reflection, LoadedComponent_$reflection, STransform_$reflection, Component_$reflection, BoundingBox_$reflection, XYPos_$reflection, Rotation_$reflection, Port_$reflection, Edge_$reflection, XYPos } from "../Common/CommonTypes.js";
import { Compose_Lens, Compose_Lens_op_GreaterMinusGreater_Z15C92E89 } from "../Common/Optics.js";
import { Union, Record } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { unit_type, lambda_type, bigint_type, tuple_type, anonRecord_type, string_type, bool_type, list_type, union_type, class_type, int32_type, option_type, array_type, record_type, float64_type } from "../fable_modules/fable-library-js.5.13.0/Reflection.js";
import { MouseOp_$reflection, MouseT_$reflection } from "../Common/DrawHelpers.js";
import { add, tryFind } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { printf, toFail } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { CompilationProfile_$reflection } from "../VerilogComponent/Verilog.js";

export function unSnapPositon_$004034() {
    return [(s) => s.UnSnapPosition, (u) => ((s_1) => (new DrawModelType_Snap(u, s_1.SnapPosition, s_1.SnapIndicatorPos)))];
}

export const unSnapPositon_$004034$002D1 = new Lazy(unSnapPositon_$004034);

export function snapPosition_$004035() {
    return [(s) => s.SnapPosition, (u) => ((s_1) => (new DrawModelType_Snap(s_1.UnSnapPosition, u, s_1.SnapIndicatorPos)))];
}

export const snapPosition_$004035$002D1 = new Lazy(snapPosition_$004035);

export function snapIndicatorPos_$004036() {
    return [(s) => s.SnapIndicatorPos, (u) => ((s_1) => (new DrawModelType_Snap(s_1.UnSnapPosition, s_1.SnapPosition, u)))];
}

export const snapIndicatorPos_$004036$002D1 = new Lazy(snapIndicatorPos_$004036);

export function snapData_$004047() {
    return [(inf) => inf.SnapData, (s) => ((inf_1) => (new DrawModelType_SnapInfo(s, inf_1.SnapOpt)))];
}

export const snapData_$004047$002D1 = new Lazy(snapData_$004047);

export function snapOpt_$004048() {
    return [(inf) => inf.SnapOpt, (s) => ((inf_1) => (new DrawModelType_SnapInfo(inf_1.SnapData, s)))];
}

export const snapOpt_$004048$002D1 = new Lazy(snapOpt_$004048);

export function snapX_$004051() {
    return [(xy) => xy.SnapX, (s) => ((xy_1) => (new DrawModelType_SnapXY(s, xy_1.SnapY)))];
}

export const snapX_$004051$002D1 = new Lazy(snapX_$004051);

export function snapY_$004052() {
    return [(xy) => xy.SnapY, (s) => ((xy_1) => (new DrawModelType_SnapXY(xy_1.SnapX, s)))];
}

export const snapY_$004052$002D1 = new Lazy(snapY_$004052);

export function none$004075() {
    return new DrawModelType_Highlighted(empty({
        Compare: (x, y) => (compare(x, y) | 0),
    }), empty({
        Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
    }));
}

export const none$004075$002D1 = new Lazy(none$004075);

export function compColour$004079() {
    return "lightgreen";
}

export const compColour$004079$002D1 = new Lazy(compColour$004079);

export function order_$0040109() {
    return [(a) => a.Order, (s) => ((a_1) => (new DrawModelType_SymbolT_PortMaps(s, a_1.Orientation)))];
}

export const order_$0040109$002D1 = new Lazy(order_$0040109);

export function orientation_$0040110() {
    return [(a) => a.Orientation, (s) => ((a_1) => (new DrawModelType_SymbolT_PortMaps(a_1.Order, s)))];
}

export const orientation_$0040110$002D1 = new Lazy(orientation_$0040110);

export function showPorts_$0040138() {
    return [(a) => a.ShowPorts, (s) => ((a_1) => (new DrawModelType_SymbolT_AppearanceT(s, a_1.ShowCorners, a_1.HighlightLabel, a_1.Colour, a_1.Opacity)))];
}

export const showPorts_$0040138$002D1 = new Lazy(showPorts_$0040138);

export function showCorners_$0040140() {
    return [(a) => a.ShowCorners, (s) => ((a_1) => (new DrawModelType_SymbolT_AppearanceT(a_1.ShowPorts, s, a_1.HighlightLabel, a_1.Colour, a_1.Opacity)))];
}

export const showCorners_$0040140$002D1 = new Lazy(showCorners_$0040140);

export function highlightLabel_$0040141() {
    return [(a) => a.HighlightLabel, (s) => ((a_1) => (new DrawModelType_SymbolT_AppearanceT(a_1.ShowPorts, a_1.ShowCorners, s, a_1.Colour, a_1.Opacity)))];
}

export const highlightLabel_$0040141$002D1 = new Lazy(highlightLabel_$0040141);

export function colour_$0040142() {
    return [(a) => a.Colour, (s) => ((a_1) => (new DrawModelType_SymbolT_AppearanceT(a_1.ShowPorts, a_1.ShowCorners, a_1.HighlightLabel, s, a_1.Opacity)))];
}

export const colour_$0040142$002D1 = new Lazy(colour_$0040142);

export function opacity_$0040143() {
    return [(a) => a.Opacity, (s) => ((a_1) => (new DrawModelType_SymbolT_AppearanceT(a_1.ShowPorts, a_1.ShowCorners, a_1.HighlightLabel, a_1.Colour, s)))];
}

export const opacity_$0040143$002D1 = new Lazy(opacity_$0040143);

export function appearance_$0040250() {
    return [(a) => a.Appearance, (s) => ((a_1) => (new DrawModelType_SymbolT_Symbol(a_1.Pos, a_1.CentrePos, a_1.OffsetFromBBCentre, a_1.InWidth0, a_1.InWidth1, a_1.InWidths, a_1.LabelBoundingBox, a_1.LabelHasDefaultPos, a_1.LabelRotation, s, a_1.Id, a_1.Component, a_1.Annotation, a_1.Moving, a_1.IsClocked, a_1.STransform, a_1.ReversedInputPorts, a_1.PortMaps, a_1.HScale, a_1.VScale, a_1.MovingPort, a_1.MovingPortTarget, a_1.ArrayText)))];
}

export const appearance_$0040250$002D1 = new Lazy(appearance_$0040250);

export function moving_$0040251() {
    return [(a) => a.Moving, (s) => ((a_1) => (new DrawModelType_SymbolT_Symbol(a_1.Pos, a_1.CentrePos, a_1.OffsetFromBBCentre, a_1.InWidth0, a_1.InWidth1, a_1.InWidths, a_1.LabelBoundingBox, a_1.LabelHasDefaultPos, a_1.LabelRotation, a_1.Appearance, a_1.Id, a_1.Component, a_1.Annotation, s, a_1.IsClocked, a_1.STransform, a_1.ReversedInputPorts, a_1.PortMaps, a_1.HScale, a_1.VScale, a_1.MovingPort, a_1.MovingPortTarget, a_1.ArrayText)))];
}

export const moving_$0040251$002D1 = new Lazy(moving_$0040251);

export function labelBoundingBox_$0040252() {
    return [(a) => a.LabelBoundingBox, (s) => ((a_1) => (new DrawModelType_SymbolT_Symbol(a_1.Pos, a_1.CentrePos, a_1.OffsetFromBBCentre, a_1.InWidth0, a_1.InWidth1, a_1.InWidths, s, a_1.LabelHasDefaultPos, a_1.LabelRotation, a_1.Appearance, a_1.Id, a_1.Component, a_1.Annotation, a_1.Moving, a_1.IsClocked, a_1.STransform, a_1.ReversedInputPorts, a_1.PortMaps, a_1.HScale, a_1.VScale, a_1.MovingPort, a_1.MovingPortTarget, a_1.ArrayText)))];
}

export const labelBoundingBox_$0040252$002D1 = new Lazy(labelBoundingBox_$0040252);

export function portMaps_$0040253() {
    return [(a) => a.PortMaps, (s) => ((a_1) => (new DrawModelType_SymbolT_Symbol(a_1.Pos, a_1.CentrePos, a_1.OffsetFromBBCentre, a_1.InWidth0, a_1.InWidth1, a_1.InWidths, a_1.LabelBoundingBox, a_1.LabelHasDefaultPos, a_1.LabelRotation, a_1.Appearance, a_1.Id, a_1.Component, a_1.Annotation, a_1.Moving, a_1.IsClocked, a_1.STransform, a_1.ReversedInputPorts, s, a_1.HScale, a_1.VScale, a_1.MovingPort, a_1.MovingPortTarget, a_1.ArrayText)))];
}

export const portMaps_$0040253$002D1 = new Lazy(portMaps_$0040253);

export function movingPort_$0040254() {
    return [(a) => a.MovingPort, (s) => ((a_1) => (new DrawModelType_SymbolT_Symbol(a_1.Pos, a_1.CentrePos, a_1.OffsetFromBBCentre, a_1.InWidth0, a_1.InWidth1, a_1.InWidths, a_1.LabelBoundingBox, a_1.LabelHasDefaultPos, a_1.LabelRotation, a_1.Appearance, a_1.Id, a_1.Component, a_1.Annotation, a_1.Moving, a_1.IsClocked, a_1.STransform, a_1.ReversedInputPorts, a_1.PortMaps, a_1.HScale, a_1.VScale, s, a_1.MovingPortTarget, a_1.ArrayText)))];
}

export const movingPort_$0040254$002D1 = new Lazy(movingPort_$0040254);

export function movingPortTarget_$0040255() {
    return [(a) => a.MovingPortTarget, (s) => ((a_1) => (new DrawModelType_SymbolT_Symbol(a_1.Pos, a_1.CentrePos, a_1.OffsetFromBBCentre, a_1.InWidth0, a_1.InWidth1, a_1.InWidths, a_1.LabelBoundingBox, a_1.LabelHasDefaultPos, a_1.LabelRotation, a_1.Appearance, a_1.Id, a_1.Component, a_1.Annotation, a_1.Moving, a_1.IsClocked, a_1.STransform, a_1.ReversedInputPorts, a_1.PortMaps, a_1.HScale, a_1.VScale, a_1.MovingPort, s, a_1.ArrayText)))];
}

export const movingPortTarget_$0040255$002D1 = new Lazy(movingPortTarget_$0040255);

export function component_$0040256() {
    return [(a) => a.Component, (s) => ((a_1) => (new DrawModelType_SymbolT_Symbol(a_1.Pos, a_1.CentrePos, a_1.OffsetFromBBCentre, a_1.InWidth0, a_1.InWidth1, a_1.InWidths, a_1.LabelBoundingBox, a_1.LabelHasDefaultPos, a_1.LabelRotation, a_1.Appearance, a_1.Id, s, a_1.Annotation, a_1.Moving, a_1.IsClocked, a_1.STransform, a_1.ReversedInputPorts, a_1.PortMaps, a_1.HScale, a_1.VScale, a_1.MovingPort, a_1.MovingPortTarget, a_1.ArrayText)))];
}

export const component_$0040256$002D1 = new Lazy(component_$0040256);

export function posOfSym_$0040257() {
    return [(a) => a.Pos, (s) => ((a_1) => (new DrawModelType_SymbolT_Symbol(s, a_1.CentrePos, a_1.OffsetFromBBCentre, a_1.InWidth0, a_1.InWidth1, a_1.InWidths, a_1.LabelBoundingBox, a_1.LabelHasDefaultPos, a_1.LabelRotation, a_1.Appearance, a_1.Id, a_1.Component, a_1.Annotation, a_1.Moving, a_1.IsClocked, a_1.STransform, a_1.ReversedInputPorts, a_1.PortMaps, a_1.HScale, a_1.VScale, a_1.MovingPort, a_1.MovingPortTarget, a_1.ArrayText)))];
}

export const posOfSym_$0040257$002D1 = new Lazy(posOfSym_$0040257);

export function getScaleF$0040258() {
    return (option) => defaultArg(option, 1);
}

export const getScaleF$0040258$002D1 = new Lazy(getScaleF$0040258);

export function scaleF_$0040259() {
    return [(sym) => (new XYPos(getScaleF$0040258$002D1.Value(sym.HScale), getScaleF$0040258$002D1.Value(sym.VScale))), (sf) => ((sym_1) => (new DrawModelType_SymbolT_Symbol(sym_1.Pos, sym_1.CentrePos, sym_1.OffsetFromBBCentre, sym_1.InWidth0, sym_1.InWidth1, sym_1.InWidths, sym_1.LabelBoundingBox, sym_1.LabelHasDefaultPos, sym_1.LabelRotation, sym_1.Appearance, sym_1.Id, sym_1.Component, sym_1.Annotation, sym_1.Moving, sym_1.IsClocked, sym_1.STransform, sym_1.ReversedInputPorts, sym_1.PortMaps, sf.X, sf.Y, sym_1.MovingPort, sym_1.MovingPortTarget, sym_1.ArrayText)))];
}

export const scaleF_$0040259$002D1 = new Lazy(scaleF_$0040259);

export function symbols_$0040341() {
    return [(m) => m.Symbols, (s) => ((m_1) => (new DrawModelType_SymbolT_Model(s, m_1.CopiedSymbols, m_1.Ports, m_1.InputPortsConnected, m_1.OutputPortsConnected, m_1.Theme, m_1.HintPane)))];
}

export const symbols_$0040341$002D1 = new Lazy(symbols_$0040341);

export function ports_$0040342() {
    return [(m) => m.Ports, (w) => ((m_1) => (new DrawModelType_SymbolT_Model(m_1.Symbols, m_1.CopiedSymbols, w, m_1.InputPortsConnected, m_1.OutputPortsConnected, m_1.Theme, m_1.HintPane)))];
}

export const ports_$0040342$002D1 = new Lazy(ports_$0040342);

export function hintPane_$0040344() {
    return [(m) => m.HintPane, (s) => ((m_1) => (new DrawModelType_SymbolT_Model(m_1.Symbols, m_1.CopiedSymbols, m_1.Ports, m_1.InputPortsConnected, m_1.OutputPortsConnected, m_1.Theme, s)))];
}

export const hintPane_$0040344$002D1 = new Lazy(hintPane_$0040344);

export function segments_$0040413() {
    return [(m) => m.Segments, (s) => ((m_1) => (new DrawModelType_BusWireT_Wire(m_1.WId, m_1.InputPort, m_1.OutputPort, m_1.Color, m_1.Width, s, m_1.StartPos, m_1.InitialOrientation)))];
}

export const segments_$0040413$002D1 = new Lazy(segments_$0040413);

export function mode_$0040414() {
    return [(m) => m.Mode, (s) => ((m_1) => (new DrawModelType_BusWireT_Segment(m_1.Index, m_1.Length, m_1.WireId, m_1.IntersectOrJumpList, m_1.Draggable, s)))];
}

export const mode_$0040414$002D1 = new Lazy(mode_$0040414);

export function symbol_$0040470() {
    return [(m) => m.Symbol, (w) => ((m_1) => (new DrawModelType_BusWireT_Model(w, m_1.Wires, m_1.CopiedWires, m_1.SelectedSegment, m_1.LastMousePos, m_1.ErrorWires, m_1.Notifications, m_1.Type, m_1.ArrowDisplay, m_1.SnapToNet)))];
}

export const symbol_$0040470$002D1 = new Lazy(symbol_$0040470);

export function wires_$0040471() {
    return [(m) => m.Wires, (w) => ((m_1) => (new DrawModelType_BusWireT_Model(m_1.Symbol, w, m_1.CopiedWires, m_1.SelectedSegment, m_1.LastMousePos, m_1.ErrorWires, m_1.Notifications, m_1.Type, m_1.ArrowDisplay, m_1.SnapToNet)))];
}

export const wires_$0040471$002D1 = new Lazy(wires_$0040471);

export function move_$0040495() {
    return [(m) => m.Move, (w) => ((m_1) => (new DrawModelType_SheetT_XYPosMov(m_1.Pos, w)))];
}

export const move_$0040495$002D1 = new Lazy(move_$0040495);

export function pos_$0040496() {
    return [(m) => m.Pos, (w) => ((m_1) => (new DrawModelType_SheetT_XYPosMov(w, m_1.Move)))];
}

export const pos_$0040496$002D1 = new Lazy(pos_$0040496);

export function wire_$0040782() {
    return [(m) => m.Wire, (w) => ((m_1) => (new DrawModelType_SheetT_Model(w, m_1.PopupViewFunc, m_1.PopupDialogData, m_1.BoundingBoxes, m_1.LastValidBoundingBoxes, m_1.SelectedLabel, m_1.SelectedComponents, m_1.SelectedWires, m_1.NearbyComponents, m_1.HoveredWire, m_1.ErrorComponents, m_1.DragToSelectBox, m_1.ConnectPortsLine, m_1.TargetPortId, m_1.Action, m_1.ShowGrid, m_1.CursorType, m_1.LastCursorType, m_1.LastValidPos, m_1.LastValidSymbol, m_1.SymbolEdit, m_1.SnapSymbols, m_1.SnapSegments, m_1.Zoom, m_1.CanvasSize, m_1.TmpModel, m_1.ScalingTmpModel, m_1.UndoList, m_1.RedoList, m_1.AutomaticScrolling, m_1.ScreenScrollPos, m_1.PendingZoomCenter, m_1.LastMousePos, m_1.ScalingBoxCentrePos, m_1.InitMouseToScalingBoxCentre, m_1.ScrollingLastMousePos, m_1.LastMousePosForSnap, m_1.MouseCounter, m_1.CtrlKeyDown, m_1.SpaceKeyDown, m_1.PrevWireSelection, m_1.OfferPasteArray, m_1.ScalingBox, m_1.Compiling, m_1.CompilationStatus, m_1.CompilationJob, m_1.DebugState, m_1.DebugData, m_1.DebugMappings, m_1.DebugIsConnected, m_1.DebugDevice)))];
}

export const wire_$0040782$002D1 = new Lazy(wire_$0040782);

export function selectedComponents_$0040783() {
    return [(m) => m.SelectedComponents, (sc) => ((m_1) => (new DrawModelType_SheetT_Model(m_1.Wire, m_1.PopupViewFunc, m_1.PopupDialogData, m_1.BoundingBoxes, m_1.LastValidBoundingBoxes, m_1.SelectedLabel, sc, m_1.SelectedWires, m_1.NearbyComponents, m_1.HoveredWire, m_1.ErrorComponents, m_1.DragToSelectBox, m_1.ConnectPortsLine, m_1.TargetPortId, m_1.Action, m_1.ShowGrid, m_1.CursorType, m_1.LastCursorType, m_1.LastValidPos, m_1.LastValidSymbol, m_1.SymbolEdit, m_1.SnapSymbols, m_1.SnapSegments, m_1.Zoom, m_1.CanvasSize, m_1.TmpModel, m_1.ScalingTmpModel, m_1.UndoList, m_1.RedoList, m_1.AutomaticScrolling, m_1.ScreenScrollPos, m_1.PendingZoomCenter, m_1.LastMousePos, m_1.ScalingBoxCentrePos, m_1.InitMouseToScalingBoxCentre, m_1.ScrollingLastMousePos, m_1.LastMousePosForSnap, m_1.MouseCounter, m_1.CtrlKeyDown, m_1.SpaceKeyDown, m_1.PrevWireSelection, m_1.OfferPasteArray, m_1.ScalingBox, m_1.Compiling, m_1.CompilationStatus, m_1.CompilationJob, m_1.DebugState, m_1.DebugData, m_1.DebugMappings, m_1.DebugIsConnected, m_1.DebugDevice)))];
}

export const selectedComponents_$0040783$002D1 = new Lazy(selectedComponents_$0040783);

export function selectedWires_$0040784() {
    return [(m) => m.SelectedWires, (sw) => ((m_1) => (new DrawModelType_SheetT_Model(m_1.Wire, m_1.PopupViewFunc, m_1.PopupDialogData, m_1.BoundingBoxes, m_1.LastValidBoundingBoxes, m_1.SelectedLabel, m_1.SelectedComponents, sw, m_1.NearbyComponents, m_1.HoveredWire, m_1.ErrorComponents, m_1.DragToSelectBox, m_1.ConnectPortsLine, m_1.TargetPortId, m_1.Action, m_1.ShowGrid, m_1.CursorType, m_1.LastCursorType, m_1.LastValidPos, m_1.LastValidSymbol, m_1.SymbolEdit, m_1.SnapSymbols, m_1.SnapSegments, m_1.Zoom, m_1.CanvasSize, m_1.TmpModel, m_1.ScalingTmpModel, m_1.UndoList, m_1.RedoList, m_1.AutomaticScrolling, m_1.ScreenScrollPos, m_1.PendingZoomCenter, m_1.LastMousePos, m_1.ScalingBoxCentrePos, m_1.InitMouseToScalingBoxCentre, m_1.ScrollingLastMousePos, m_1.LastMousePosForSnap, m_1.MouseCounter, m_1.CtrlKeyDown, m_1.SpaceKeyDown, m_1.PrevWireSelection, m_1.OfferPasteArray, m_1.ScalingBox, m_1.Compiling, m_1.CompilationStatus, m_1.CompilationJob, m_1.DebugState, m_1.DebugData, m_1.DebugMappings, m_1.DebugIsConnected, m_1.DebugDevice)))];
}

export const selectedWires_$0040784$002D1 = new Lazy(selectedWires_$0040784);

export function boundingBoxes_$0040785() {
    return [(m) => m.BoundingBoxes, (bb) => ((m_1) => (new DrawModelType_SheetT_Model(m_1.Wire, m_1.PopupViewFunc, m_1.PopupDialogData, bb, m_1.LastValidBoundingBoxes, m_1.SelectedLabel, m_1.SelectedComponents, m_1.SelectedWires, m_1.NearbyComponents, m_1.HoveredWire, m_1.ErrorComponents, m_1.DragToSelectBox, m_1.ConnectPortsLine, m_1.TargetPortId, m_1.Action, m_1.ShowGrid, m_1.CursorType, m_1.LastCursorType, m_1.LastValidPos, m_1.LastValidSymbol, m_1.SymbolEdit, m_1.SnapSymbols, m_1.SnapSegments, m_1.Zoom, m_1.CanvasSize, m_1.TmpModel, m_1.ScalingTmpModel, m_1.UndoList, m_1.RedoList, m_1.AutomaticScrolling, m_1.ScreenScrollPos, m_1.PendingZoomCenter, m_1.LastMousePos, m_1.ScalingBoxCentrePos, m_1.InitMouseToScalingBoxCentre, m_1.ScrollingLastMousePos, m_1.LastMousePosForSnap, m_1.MouseCounter, m_1.CtrlKeyDown, m_1.SpaceKeyDown, m_1.PrevWireSelection, m_1.OfferPasteArray, m_1.ScalingBox, m_1.Compiling, m_1.CompilationStatus, m_1.CompilationJob, m_1.DebugState, m_1.DebugData, m_1.DebugMappings, m_1.DebugIsConnected, m_1.DebugDevice)))];
}

export const boundingBoxes_$0040785$002D1 = new Lazy(boundingBoxes_$0040785);

export function wires_$0040789$002D2() {
    const l = wire_$0040782$002D1.Value;
    return Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, wires_$0040471$002D1.Value)(l);
}

export const wires_$0040789$002D3 = new Lazy(wires_$0040789$002D2);

export function symbol_$0040791$002D2() {
    const l = wire_$0040782$002D1.Value;
    return Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, symbol_$0040470$002D1.Value)(l);
}

export const symbol_$0040791$002D3 = new Lazy(symbol_$0040791$002D2);

export function symbols_$0040792$002D2() {
    let l_2;
    const l = wire_$0040782$002D1.Value;
    l_2 = Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, symbol_$0040470$002D1.Value)(l);
    return Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, symbols_$0040341$002D1.Value)(l_2);
}

export const symbols_$0040792$002D3 = new Lazy(symbols_$0040792$002D2);

export function scrollingLastMousePos_$0040794() {
    return [(m) => m.ScrollingLastMousePos, (w) => ((m_1) => (new DrawModelType_SheetT_Model(m_1.Wire, m_1.PopupViewFunc, m_1.PopupDialogData, m_1.BoundingBoxes, m_1.LastValidBoundingBoxes, m_1.SelectedLabel, m_1.SelectedComponents, m_1.SelectedWires, m_1.NearbyComponents, m_1.HoveredWire, m_1.ErrorComponents, m_1.DragToSelectBox, m_1.ConnectPortsLine, m_1.TargetPortId, m_1.Action, m_1.ShowGrid, m_1.CursorType, m_1.LastCursorType, m_1.LastValidPos, m_1.LastValidSymbol, m_1.SymbolEdit, m_1.SnapSymbols, m_1.SnapSegments, m_1.Zoom, m_1.CanvasSize, m_1.TmpModel, m_1.ScalingTmpModel, m_1.UndoList, m_1.RedoList, m_1.AutomaticScrolling, m_1.ScreenScrollPos, m_1.PendingZoomCenter, m_1.LastMousePos, m_1.ScalingBoxCentrePos, m_1.InitMouseToScalingBoxCentre, w, m_1.LastMousePosForSnap, m_1.MouseCounter, m_1.CtrlKeyDown, m_1.SpaceKeyDown, m_1.PrevWireSelection, m_1.OfferPasteArray, m_1.ScalingBox, m_1.Compiling, m_1.CompilationStatus, m_1.CompilationJob, m_1.DebugState, m_1.DebugData, m_1.DebugMappings, m_1.DebugIsConnected, m_1.DebugDevice)))];
}

export const scrollingLastMousePos_$0040794$002D1 = new Lazy(scrollingLastMousePos_$0040794);

export function lastMousePos_$0040795() {
    return [(m) => m.LastMousePos, (w) => ((m_1) => (new DrawModelType_SheetT_Model(m_1.Wire, m_1.PopupViewFunc, m_1.PopupDialogData, m_1.BoundingBoxes, m_1.LastValidBoundingBoxes, m_1.SelectedLabel, m_1.SelectedComponents, m_1.SelectedWires, m_1.NearbyComponents, m_1.HoveredWire, m_1.ErrorComponents, m_1.DragToSelectBox, m_1.ConnectPortsLine, m_1.TargetPortId, m_1.Action, m_1.ShowGrid, m_1.CursorType, m_1.LastCursorType, m_1.LastValidPos, m_1.LastValidSymbol, m_1.SymbolEdit, m_1.SnapSymbols, m_1.SnapSegments, m_1.Zoom, m_1.CanvasSize, m_1.TmpModel, m_1.ScalingTmpModel, m_1.UndoList, m_1.RedoList, m_1.AutomaticScrolling, m_1.ScreenScrollPos, m_1.PendingZoomCenter, w, m_1.ScalingBoxCentrePos, m_1.InitMouseToScalingBoxCentre, m_1.ScrollingLastMousePos, m_1.LastMousePosForSnap, m_1.MouseCounter, m_1.CtrlKeyDown, m_1.SpaceKeyDown, m_1.PrevWireSelection, m_1.OfferPasteArray, m_1.ScalingBox, m_1.Compiling, m_1.CompilationStatus, m_1.CompilationJob, m_1.DebugState, m_1.DebugData, m_1.DebugMappings, m_1.DebugIsConnected, m_1.DebugDevice)))];
}

export const lastMousePos_$0040795$002D1 = new Lazy(lastMousePos_$0040795);

export function screenScrollPos_$0040796() {
    return [(m) => m.ScreenScrollPos, (w) => ((m_1) => (new DrawModelType_SheetT_Model(m_1.Wire, m_1.PopupViewFunc, m_1.PopupDialogData, m_1.BoundingBoxes, m_1.LastValidBoundingBoxes, m_1.SelectedLabel, m_1.SelectedComponents, m_1.SelectedWires, m_1.NearbyComponents, m_1.HoveredWire, m_1.ErrorComponents, m_1.DragToSelectBox, m_1.ConnectPortsLine, m_1.TargetPortId, m_1.Action, m_1.ShowGrid, m_1.CursorType, m_1.LastCursorType, m_1.LastValidPos, m_1.LastValidSymbol, m_1.SymbolEdit, m_1.SnapSymbols, m_1.SnapSegments, m_1.Zoom, m_1.CanvasSize, m_1.TmpModel, m_1.ScalingTmpModel, m_1.UndoList, m_1.RedoList, m_1.AutomaticScrolling, w, m_1.PendingZoomCenter, m_1.LastMousePos, m_1.ScalingBoxCentrePos, m_1.InitMouseToScalingBoxCentre, m_1.ScrollingLastMousePos, m_1.LastMousePosForSnap, m_1.MouseCounter, m_1.CtrlKeyDown, m_1.SpaceKeyDown, m_1.PrevWireSelection, m_1.OfferPasteArray, m_1.ScalingBox, m_1.Compiling, m_1.CompilationStatus, m_1.CompilationJob, m_1.DebugState, m_1.DebugData, m_1.DebugMappings, m_1.DebugIsConnected, m_1.DebugDevice)))];
}

export const screenScrollPos_$0040796$002D1 = new Lazy(screenScrollPos_$0040796);

export function lastMousePosForSnap_$0040797() {
    return [(m) => m.LastMousePosForSnap, (w) => ((m_1) => (new DrawModelType_SheetT_Model(m_1.Wire, m_1.PopupViewFunc, m_1.PopupDialogData, m_1.BoundingBoxes, m_1.LastValidBoundingBoxes, m_1.SelectedLabel, m_1.SelectedComponents, m_1.SelectedWires, m_1.NearbyComponents, m_1.HoveredWire, m_1.ErrorComponents, m_1.DragToSelectBox, m_1.ConnectPortsLine, m_1.TargetPortId, m_1.Action, m_1.ShowGrid, m_1.CursorType, m_1.LastCursorType, m_1.LastValidPos, m_1.LastValidSymbol, m_1.SymbolEdit, m_1.SnapSymbols, m_1.SnapSegments, m_1.Zoom, m_1.CanvasSize, m_1.TmpModel, m_1.ScalingTmpModel, m_1.UndoList, m_1.RedoList, m_1.AutomaticScrolling, m_1.ScreenScrollPos, m_1.PendingZoomCenter, m_1.LastMousePos, m_1.ScalingBoxCentrePos, m_1.InitMouseToScalingBoxCentre, m_1.ScrollingLastMousePos, w, m_1.MouseCounter, m_1.CtrlKeyDown, m_1.SpaceKeyDown, m_1.PrevWireSelection, m_1.OfferPasteArray, m_1.ScalingBox, m_1.Compiling, m_1.CompilationStatus, m_1.CompilationJob, m_1.DebugState, m_1.DebugData, m_1.DebugMappings, m_1.DebugIsConnected, m_1.DebugDevice)))];
}

export const lastMousePosForSnap_$0040797$002D1 = new Lazy(lastMousePosForSnap_$0040797);

export function canvasSize_$0040798() {
    return [(m) => m.CanvasSize, (w) => ((m_1) => (new DrawModelType_SheetT_Model(m_1.Wire, m_1.PopupViewFunc, m_1.PopupDialogData, m_1.BoundingBoxes, m_1.LastValidBoundingBoxes, m_1.SelectedLabel, m_1.SelectedComponents, m_1.SelectedWires, m_1.NearbyComponents, m_1.HoveredWire, m_1.ErrorComponents, m_1.DragToSelectBox, m_1.ConnectPortsLine, m_1.TargetPortId, m_1.Action, m_1.ShowGrid, m_1.CursorType, m_1.LastCursorType, m_1.LastValidPos, m_1.LastValidSymbol, m_1.SymbolEdit, m_1.SnapSymbols, m_1.SnapSegments, m_1.Zoom, w, m_1.TmpModel, m_1.ScalingTmpModel, m_1.UndoList, m_1.RedoList, m_1.AutomaticScrolling, m_1.ScreenScrollPos, m_1.PendingZoomCenter, m_1.LastMousePos, m_1.ScalingBoxCentrePos, m_1.InitMouseToScalingBoxCentre, m_1.ScrollingLastMousePos, m_1.LastMousePosForSnap, m_1.MouseCounter, m_1.CtrlKeyDown, m_1.SpaceKeyDown, m_1.PrevWireSelection, m_1.OfferPasteArray, m_1.ScalingBox, m_1.Compiling, m_1.CompilationStatus, m_1.CompilationJob, m_1.DebugState, m_1.DebugData, m_1.DebugMappings, m_1.DebugIsConnected, m_1.DebugDevice)))];
}

export const canvasSize_$0040798$002D1 = new Lazy(canvasSize_$0040798);

export function zoom_$0040800() {
    return [(m) => m.Zoom, (w) => ((m_1) => (new DrawModelType_SheetT_Model(m_1.Wire, m_1.PopupViewFunc, m_1.PopupDialogData, m_1.BoundingBoxes, m_1.LastValidBoundingBoxes, m_1.SelectedLabel, m_1.SelectedComponents, m_1.SelectedWires, m_1.NearbyComponents, m_1.HoveredWire, m_1.ErrorComponents, m_1.DragToSelectBox, m_1.ConnectPortsLine, m_1.TargetPortId, m_1.Action, m_1.ShowGrid, m_1.CursorType, m_1.LastCursorType, m_1.LastValidPos, m_1.LastValidSymbol, m_1.SymbolEdit, m_1.SnapSymbols, m_1.SnapSegments, w, m_1.CanvasSize, m_1.TmpModel, m_1.ScalingTmpModel, m_1.UndoList, m_1.RedoList, m_1.AutomaticScrolling, m_1.ScreenScrollPos, m_1.PendingZoomCenter, m_1.LastMousePos, m_1.ScalingBoxCentrePos, m_1.InitMouseToScalingBoxCentre, m_1.ScrollingLastMousePos, m_1.LastMousePosForSnap, m_1.MouseCounter, m_1.CtrlKeyDown, m_1.SpaceKeyDown, m_1.PrevWireSelection, m_1.OfferPasteArray, m_1.ScalingBox, m_1.Compiling, m_1.CompilationStatus, m_1.CompilationJob, m_1.DebugState, m_1.DebugData, m_1.DebugMappings, m_1.DebugIsConnected, m_1.DebugDevice)))];
}

export const zoom_$0040800$002D1 = new Lazy(zoom_$0040800);

export function scalingBox_$0040802() {
    return [(m) => m.ScalingBox, (w) => ((m_1) => (new DrawModelType_SheetT_Model(m_1.Wire, m_1.PopupViewFunc, m_1.PopupDialogData, m_1.BoundingBoxes, m_1.LastValidBoundingBoxes, m_1.SelectedLabel, m_1.SelectedComponents, m_1.SelectedWires, m_1.NearbyComponents, m_1.HoveredWire, m_1.ErrorComponents, m_1.DragToSelectBox, m_1.ConnectPortsLine, m_1.TargetPortId, m_1.Action, m_1.ShowGrid, m_1.CursorType, m_1.LastCursorType, m_1.LastValidPos, m_1.LastValidSymbol, m_1.SymbolEdit, m_1.SnapSymbols, m_1.SnapSegments, m_1.Zoom, m_1.CanvasSize, m_1.TmpModel, m_1.ScalingTmpModel, m_1.UndoList, m_1.RedoList, m_1.AutomaticScrolling, m_1.ScreenScrollPos, m_1.PendingZoomCenter, m_1.LastMousePos, m_1.ScalingBoxCentrePos, m_1.InitMouseToScalingBoxCentre, m_1.ScrollingLastMousePos, m_1.LastMousePosForSnap, m_1.MouseCounter, m_1.CtrlKeyDown, m_1.SpaceKeyDown, m_1.PrevWireSelection, m_1.OfferPasteArray, w, m_1.Compiling, m_1.CompilationStatus, m_1.CompilationJob, m_1.DebugState, m_1.DebugData, m_1.DebugMappings, m_1.DebugIsConnected, m_1.DebugDevice)))];
}

export const scalingBox_$0040802$002D1 = new Lazy(scalingBox_$0040802);

export function symbolEdit_$0040803() {
    return [(m) => m.SymbolEdit, (w) => ((m_1) => (new DrawModelType_SheetT_Model(m_1.Wire, m_1.PopupViewFunc, m_1.PopupDialogData, m_1.BoundingBoxes, m_1.LastValidBoundingBoxes, m_1.SelectedLabel, m_1.SelectedComponents, m_1.SelectedWires, m_1.NearbyComponents, m_1.HoveredWire, m_1.ErrorComponents, m_1.DragToSelectBox, m_1.ConnectPortsLine, m_1.TargetPortId, m_1.Action, m_1.ShowGrid, m_1.CursorType, m_1.LastCursorType, m_1.LastValidPos, m_1.LastValidSymbol, w, m_1.SnapSymbols, m_1.SnapSegments, m_1.Zoom, m_1.CanvasSize, m_1.TmpModel, m_1.ScalingTmpModel, m_1.UndoList, m_1.RedoList, m_1.AutomaticScrolling, m_1.ScreenScrollPos, m_1.PendingZoomCenter, m_1.LastMousePos, m_1.ScalingBoxCentrePos, m_1.InitMouseToScalingBoxCentre, m_1.ScrollingLastMousePos, m_1.LastMousePosForSnap, m_1.MouseCounter, m_1.CtrlKeyDown, m_1.SpaceKeyDown, m_1.PrevWireSelection, m_1.OfferPasteArray, m_1.ScalingBox, m_1.Compiling, m_1.CompilationStatus, m_1.CompilationJob, m_1.DebugState, m_1.DebugData, m_1.DebugMappings, m_1.DebugIsConnected, m_1.DebugDevice)))];
}

export const symbolEdit_$0040803$002D1 = new Lazy(symbolEdit_$0040803);

/**
 * Static 1D data defining position range within which the currently moved thing will "snap"
 * to fixed point (Snap).
 */
export class DrawModelType_SnapData extends Record {
    constructor(UpperLimit, LowerLimit, Snap, IndicatorPos) {
        super();
        this.UpperLimit = UpperLimit;
        this.LowerLimit = LowerLimit;
        this.Snap = Snap;
        this.IndicatorPos = IndicatorPos;
    }
}

export function DrawModelType_SnapData_$reflection() {
    return record_type("DrawModelType.SnapData", [], DrawModelType_SnapData, () => [["UpperLimit", float64_type], ["LowerLimit", float64_type], ["Snap", float64_type], ["IndicatorPos", float64_type]]);
}

/**
 * Dynamic data used when a symbol is being snapped
 */
export class DrawModelType_Snap extends Record {
    constructor(UnSnapPosition, SnapPosition, SnapIndicatorPos) {
        super();
        this.UnSnapPosition = UnSnapPosition;
        this.SnapPosition = SnapPosition;
        this.SnapIndicatorPos = SnapIndicatorPos;
    }
}

export function DrawModelType_Snap_$reflection() {
    return record_type("DrawModelType.Snap", [], DrawModelType_Snap, () => [["UnSnapPosition", float64_type], ["SnapPosition", float64_type], ["SnapIndicatorPos", float64_type]]);
}

/**
 * All the 1D data needed to manage snapping of a moving symbol
 */
export class DrawModelType_SnapInfo extends Record {
    constructor(SnapData, SnapOpt) {
        super();
        this.SnapData = SnapData;
        this.SnapOpt = SnapOpt;
    }
}

export function DrawModelType_SnapInfo_$reflection() {
    return record_type("DrawModelType.SnapInfo", [], DrawModelType_SnapInfo, () => [["SnapData", array_type(DrawModelType_SnapData_$reflection())], ["SnapOpt", option_type(DrawModelType_Snap_$reflection())]]);
}

export class DrawModelType_SnapXY extends Record {
    constructor(SnapX, SnapY) {
        super();
        this.SnapX = SnapX;
        this.SnapY = SnapY;
    }
}

export function DrawModelType_SnapXY_$reflection() {
    return record_type("DrawModelType.SnapXY", [], DrawModelType_SnapXY, () => [["SnapX", DrawModelType_SnapInfo_$reflection()], ["SnapY", DrawModelType_SnapInfo_$reflection()]]);
}

/**
 * What the schematic is to draw picked out, for a reason the draw block cannot know itself: at
 * present the waveform whose name the pointer is resting on, which only the UI layer knows about
 * because only it knows a simulation is running. Reaches the draw block the same way `overlay`
 * does - as an argument to SheetDisplay.view - and never as a message.
 * 
 * **Derived on every render from the state that says why, and never stored.** The highlight used
 * to be painted by the mouse handlers, which wrote the colours into the symbols and wires and put
 * them in the sheet's selection, and then unwrote them on the way out. Every one of those corner
 * cases is a transition that can be missed or arrive in the wrong order: a hover whose mouse-out
 * never came left the colour on the canvas, a repaint after it left the wire the wrong colour,
 * and ids of a simulation older than the sheet ended up in the selection where Delete could act
 * on them. As a function of the model there is nothing to put back.
 */
export class DrawModelType_Highlighted extends Record {
    constructor(HComps, HConns) {
        super();
        this.HComps = HComps;
        this.HConns = HConns;
    }
}

export function DrawModelType_Highlighted_$reflection() {
    return record_type("DrawModelType.Highlighted", [], DrawModelType_Highlighted, () => [["HComps", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [int32_type])], ["HConns", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [int32_type])]]);
}

export const DrawModelType_unSnapPositon_ = unSnapPositon_$004034$002D1.Value;

export const DrawModelType_snapPosition_ = snapPosition_$004035$002D1.Value;

export const DrawModelType_snapIndicatorPos_ = snapIndicatorPos_$004036$002D1.Value;

export const DrawModelType_snapData_ = snapData_$004047$002D1.Value;

export const DrawModelType_snapOpt_ = snapOpt_$004048$002D1.Value;

export const DrawModelType_snapX_ = snapX_$004051$002D1.Value;

export const DrawModelType_snapY_ = snapY_$004052$002D1.Value;

export const DrawModelType_HighlightedModule_none = none$004075$002D1.Value;

export const DrawModelType_HighlightedModule_compColour = compColour$004079$002D1.Value;

/**
 * Wraps around the input and output port id types
 * A port named together with the side of a connection it is: the undirected id is
 * PortId, which this carries inside InputPortId or OutputPortId.
 */
export class DrawModelType_SymbolT_DirectedPortId extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["InputId", "OutputId"];
    }
}

export function DrawModelType_SymbolT_DirectedPortId_$reflection() {
    return union_type("DrawModelType.SymbolT.DirectedPortId", [], DrawModelType_SymbolT_DirectedPortId, () => [[["Item", int32_type]], [["Item", int32_type]]]);
}

/**
 * data structures defining where ports are put on symbol boundary, by PortId - which is an
 * integer wrapper, not the string it was when this was written
 */
export class DrawModelType_SymbolT_PortMaps extends Record {
    constructor(Order, Orientation) {
        super();
        this.Order = Order;
        this.Orientation = Orientation;
    }
}

export function DrawModelType_SymbolT_PortMaps_$reflection() {
    return record_type("DrawModelType.SymbolT.PortMaps", [], DrawModelType_SymbolT_PortMaps, () => [["Order", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [Edge_$reflection(), list_type(int32_type)])], ["Orientation", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [int32_type, Edge_$reflection()])]]);
}

/**
 * data here changes how the symbol looks but has no other effect
 */
export class DrawModelType_SymbolT_ShowPorts extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ShowInput", "ShowOutput", "ShowBoth", "ShowBothForPortMovement", "ShowNone", "ShowOneTouching", "ShowOneNotTouching", "ShowTarget"];
    }
    static ShowInput = new DrawModelType_SymbolT_ShowPorts(0, []);
    static ShowOutput = new DrawModelType_SymbolT_ShowPorts(1, []);
    static ShowBoth = new DrawModelType_SymbolT_ShowPorts(2, []);
    static ShowBothForPortMovement = new DrawModelType_SymbolT_ShowPorts(3, []);
    static ShowNone = new DrawModelType_SymbolT_ShowPorts(4, []);
    static ShowTarget = new DrawModelType_SymbolT_ShowPorts(7, []);
}

export function DrawModelType_SymbolT_ShowPorts_$reflection() {
    return union_type("DrawModelType.SymbolT.ShowPorts", [], DrawModelType_SymbolT_ShowPorts, () => [[], [], [], [], [], [["Item", Port_$reflection()]], [["Item", Port_$reflection()]], []]);
}

export class DrawModelType_SymbolT_ShowCorners extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ShowAll", "DontShow"];
    }
    static ShowAll = new DrawModelType_SymbolT_ShowCorners(0, []);
    static DontShow = new DrawModelType_SymbolT_ShowCorners(1, []);
}

export function DrawModelType_SymbolT_ShowCorners_$reflection() {
    return union_type("DrawModelType.SymbolT.ShowCorners", [], DrawModelType_SymbolT_ShowCorners, () => [[], []]);
}

export class DrawModelType_SymbolT_Annotation extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ScaleButton", "RotateButton"];
    }
    static ScaleButton = new DrawModelType_SymbolT_Annotation(0, []);
}

export function DrawModelType_SymbolT_Annotation_$reflection() {
    return union_type("DrawModelType.SymbolT.Annotation", [], DrawModelType_SymbolT_Annotation, () => [[], [["Item", Rotation_$reflection()]]]);
}

export class DrawModelType_SymbolT_AppearanceT extends Record {
    constructor(ShowPorts, ShowCorners, HighlightLabel, Colour, Opacity) {
        super();
        this.ShowPorts = ShowPorts;
        this.ShowCorners = ShowCorners;
        this.HighlightLabel = HighlightLabel;
        this.Colour = Colour;
        this.Opacity = Opacity;
    }
}

export function DrawModelType_SymbolT_AppearanceT_$reflection() {
    return record_type("DrawModelType.SymbolT.AppearanceT", [], DrawModelType_SymbolT_AppearanceT, () => [["ShowPorts", DrawModelType_SymbolT_ShowPorts_$reflection()], ["ShowCorners", DrawModelType_SymbolT_ShowCorners_$reflection()], ["HighlightLabel", bool_type], ["Colour", string_type], ["Opacity", float64_type]]);
}

/**
 * This defines the colors used in teh drawblack, and therfore also the symbol color.
 */
export class DrawModelType_SymbolT_ThemeType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["White", "Light", "Colourful"];
    }
    static White = new DrawModelType_SymbolT_ThemeType(0, []);
    static Light = new DrawModelType_SymbolT_ThemeType(1, []);
    static Colourful = new DrawModelType_SymbolT_ThemeType(2, []);
}

export function DrawModelType_SymbolT_ThemeType_$reflection() {
    return union_type("DrawModelType.SymbolT.ThemeType", [], DrawModelType_SymbolT_ThemeType, () => [[], [], []]);
}

/**
 * Represents a symbol, that contains a component and all the other information needed to render it
 */
export class DrawModelType_SymbolT_Symbol extends Record {
    constructor(Pos, CentrePos, OffsetFromBBCentre, InWidth0, InWidth1, InWidths, LabelBoundingBox, LabelHasDefaultPos, LabelRotation, Appearance, Id, Component, Annotation, Moving, IsClocked, STransform, ReversedInputPorts, PortMaps, HScale, VScale, MovingPort, MovingPortTarget, ArrayText) {
        super();
        this.Pos = Pos;
        this.CentrePos = CentrePos;
        this.OffsetFromBBCentre = OffsetFromBBCentre;
        this.InWidth0 = InWidth0;
        this.InWidth1 = InWidth1;
        this.InWidths = InWidths;
        this.LabelBoundingBox = LabelBoundingBox;
        this.LabelHasDefaultPos = LabelHasDefaultPos;
        this.LabelRotation = LabelRotation;
        this.Appearance = Appearance;
        this.Id = Id;
        this.Component = Component;
        this.Annotation = Annotation;
        this.Moving = Moving;
        this.IsClocked = IsClocked;
        this.STransform = STransform;
        this.ReversedInputPorts = ReversedInputPorts;
        this.PortMaps = PortMaps;
        this.HScale = HScale;
        this.VScale = VScale;
        this.MovingPort = MovingPort;
        this.MovingPortTarget = MovingPortTarget;
        this.ArrayText = ArrayText;
    }
}

export function DrawModelType_SymbolT_Symbol_$reflection() {
    return record_type("DrawModelType.SymbolT.Symbol", [], DrawModelType_SymbolT_Symbol, () => [["Pos", XYPos_$reflection()], ["CentrePos", XYPos_$reflection()], ["OffsetFromBBCentre", XYPos_$reflection()], ["InWidth0", option_type(int32_type)], ["InWidth1", option_type(int32_type)], ["InWidths", option_type(list_type(option_type(int32_type)))], ["LabelBoundingBox", BoundingBox_$reflection()], ["LabelHasDefaultPos", bool_type], ["LabelRotation", option_type(Rotation_$reflection())], ["Appearance", DrawModelType_SymbolT_AppearanceT_$reflection()], ["Id", int32_type], ["Component", Component_$reflection()], ["Annotation", option_type(DrawModelType_SymbolT_Annotation_$reflection())], ["Moving", bool_type], ["IsClocked", bool_type], ["STransform", STransform_$reflection()], ["ReversedInputPorts", option_type(bool_type)], ["PortMaps", DrawModelType_SymbolT_PortMaps_$reflection()], ["HScale", option_type(float64_type)], ["VScale", option_type(float64_type)], ["MovingPort", option_type(anonRecord_type(["CurrPos", XYPos_$reflection()], ["PortId", int32_type]))], ["MovingPortTarget", option_type(tuple_type(XYPos_$reflection(), XYPos_$reflection()))], ["ArrayText", option_type(string_type)]]);
}

/**
 * Represents all the symbols and ports on the sheet
 */
export class DrawModelType_SymbolT_Model extends Record {
    constructor(Symbols, CopiedSymbols, Ports, InputPortsConnected, OutputPortsConnected, Theme, HintPane) {
        super();
        this.Symbols = Symbols;
        this.CopiedSymbols = CopiedSymbols;
        this.Ports = Ports;
        this.InputPortsConnected = InputPortsConnected;
        this.OutputPortsConnected = OutputPortsConnected;
        this.Theme = Theme;
        this.HintPane = HintPane;
    }
}

export function DrawModelType_SymbolT_Model_$reflection() {
    return record_type("DrawModelType.SymbolT.Model", [], DrawModelType_SymbolT_Model, () => [["Symbols", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [int32_type, DrawModelType_SymbolT_Symbol_$reflection()])], ["CopiedSymbols", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [int32_type, DrawModelType_SymbolT_Symbol_$reflection()])], ["Ports", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [int32_type, Port_$reflection()])], ["InputPortsConnected", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [int32_type])], ["OutputPortsConnected", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [int32_type, int32_type])], ["Theme", DrawModelType_SymbolT_ThemeType_$reflection()], ["HintPane", option_type(list_type(string_type))]]);
}

/**
 * The different messages coming from sheet, normally represent events
 */
export class DrawModelType_SymbolT_Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["MouseMsg", "AddSymbol", "CopySymbols", "DeleteSymbols", "ShowAllInputPorts", "ShowAllOutputPorts", "DeleteAllPorts", "MoveSymbols", "MoveLabel", "ShowPorts", "ShowCustomOnlyPorts", "SelectSymbols", "SymbolsHaveError", "ChangeLabel", "PasteSymbols", "ColorSymbols", "ErrorSymbols", "ChangeNumberOfBits", "ChangeLsb", "ChangeInputValue", "ChangeJoinNum", "ChangeScale", "ChangeConstant", "ChangeBusCompare", "ChangeReversedInputs", "ChangeAdderComponent", "ChangeCustom", "ChangeCounterComponent", "ResetModel", "LoadComponents", "WriteMemoryLine", "WriteMemoryType", "UpdateMemory", "RotateLeft", "RotateAntiClockAng", "Flip", "MovePort", "MovePortDone", "ShowCustomCorners", "HideCustomCorners", "ResizeSymbol", "ResizeSymbolDone", "SaveSymbols", "SetTheme", "UpdateBoundingBoxes"];
    }
    static ShowAllInputPorts = new DrawModelType_SymbolT_Msg(4, []);
    static ShowAllOutputPorts = new DrawModelType_SymbolT_Msg(5, []);
    static DeleteAllPorts = new DrawModelType_SymbolT_Msg(6, []);
    static ResetModel = new DrawModelType_SymbolT_Msg(28, []);
    static SaveSymbols = new DrawModelType_SymbolT_Msg(42, []);
    static UpdateBoundingBoxes = new DrawModelType_SymbolT_Msg(44, []);
}

export function DrawModelType_SymbolT_Msg_$reflection() {
    return union_type("DrawModelType.SymbolT.Msg", [], DrawModelType_SymbolT_Msg, () => [[["Item", MouseT_$reflection()]], [["Item1", list_type(LoadedComponent_$reflection())], ["pos", XYPos_$reflection()], ["compType", ComponentType_$reflection()], ["lbl", string_type]], [["Item", list_type(int32_type)]], [["sIds", list_type(int32_type)]], [], [], [], [["compList", list_type(int32_type)], ["move", XYPos_$reflection()]], [["compId", int32_type], ["move", XYPos_$reflection()]], [["Item", list_type(int32_type)]], [["Item", list_type(int32_type)]], [["Item", list_type(int32_type)]], [["sIds", list_type(int32_type)]], [["sId", int32_type], ["newLabel", string_type]], [["sIds", list_type(int32_type)]], [["compList", list_type(int32_type)], ["colour", HighLightColor_$reflection()]], [["errorIds", list_type(int32_type)], ["selectIds", list_type(int32_type)], ["isDragAndDrop", bool_type]], [["compId", int32_type], ["NewBits", int32_type]], [["compId", int32_type], ["NewBits", bigint_type]], [["compId", int32_type], ["newVal", bigint_type]], [["compId", int32_type], ["newNum", int32_type]], [["compId", int32_type], ["newScale", float64_type], ["whichScale", string_type]], [["compId", int32_type], ["NewBits", bigint_type], ["NewText", string_type]], [["compId", int32_type], ["NewBits", bigint_type], ["NewText", string_type]], [["compId", int32_type]], [["compId", int32_type], ["oldComp", Component_$reflection()], ["newComp", ComponentType_$reflection()]], [["compId", int32_type], ["oldComp", Component_$reflection()], ["newComp", ComponentType_$reflection()]], [["compId", int32_type], ["oldComp", Component_$reflection()], ["newComp", ComponentType_$reflection()]], [], [["Item1", list_type(LoadedComponent_$reflection())], ["Item2", list_type(Component_$reflection())]], [["Item1", int32_type], ["Item2", bigint_type], ["Item3", bigint_type]], [["Item1", int32_type], ["Item2", ComponentType_$reflection()]], [["Item1", int32_type], ["Item2", lambda_type(Memory1_$reflection(), Memory1_$reflection())]], [["compList", list_type(int32_type)], ["Item2", Rotation_$reflection()]], [["compList", list_type(int32_type)], ["Item2", Rotation_$reflection()]], [["compList", list_type(int32_type)], ["orientation", string_type]], [["portId", int32_type], ["move", XYPos_$reflection()]], [["portId", int32_type], ["move", XYPos_$reflection()]], [["compList", list_type(int32_type)]], [["compList", list_type(int32_type)]], [["compId", int32_type], ["corner", XYPos_$reflection()], ["move", XYPos_$reflection()]], [["compId", int32_type], ["resetSymbol", option_type(DrawModelType_SymbolT_Symbol_$reflection())], ["corner", XYPos_$reflection()], ["move", XYPos_$reflection()]], [], [["Item", DrawModelType_SymbolT_ThemeType_$reflection()]], []]);
}

export const DrawModelType_SymbolT_order_ = order_$0040109$002D1.Value;

export const DrawModelType_SymbolT_orientation_ = orientation_$0040110$002D1.Value;

export const DrawModelType_SymbolT_showPorts_ = showPorts_$0040138$002D1.Value;

export const DrawModelType_SymbolT_showCorners_ = showCorners_$0040140$002D1.Value;

export const DrawModelType_SymbolT_highlightLabel_ = highlightLabel_$0040141$002D1.Value;

export const DrawModelType_SymbolT_colour_ = colour_$0040142$002D1.Value;

export const DrawModelType_SymbolT_opacity_ = opacity_$0040143$002D1.Value;

export const DrawModelType_SymbolT_appearance_ = appearance_$0040250$002D1.Value;

export const DrawModelType_SymbolT_moving_ = moving_$0040251$002D1.Value;

export const DrawModelType_SymbolT_labelBoundingBox_ = labelBoundingBox_$0040252$002D1.Value;

export const DrawModelType_SymbolT_portMaps_ = portMaps_$0040253$002D1.Value;

export const DrawModelType_SymbolT_movingPort_ = movingPort_$0040254$002D1.Value;

export const DrawModelType_SymbolT_movingPortTarget_ = movingPortTarget_$0040255$002D1.Value;

export const DrawModelType_SymbolT_component_ = component_$0040256$002D1.Value;

export const DrawModelType_SymbolT_posOfSym_ = posOfSym_$0040257$002D1.Value;

export const DrawModelType_SymbolT_getScaleF = getScaleF$0040258$002D1.Value;

export const DrawModelType_SymbolT_scaleF_ = scaleF_$0040259$002D1.Value;

export const DrawModelType_SymbolT_symbols_ = symbols_$0040341$002D1.Value;

export const DrawModelType_SymbolT_ports_ = ports_$0040342$002D1.Value;

export function DrawModelType_SymbolT_symbolOf_(k) {
    let k_1;
    const l = symbols_$0040341$002D1.Value;
    return Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, (k_1 = k, [(arg_1) => {
        const _arg = tryFind(k_1, arg_1);
        return (_arg == null) ? toFail(printf("%s"))("What? Symbol id lookup in model failed") : _arg;
    }, (v_1) => ((x) => add(k_1, v_1, x))]))(l);
}

export const DrawModelType_SymbolT_hintPane_ = hintPane_$0040344$002D1.Value;

export class DrawModelType_BusWireT_SnapPosition extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["High", "Mid", "Low"];
    }
    static High = new DrawModelType_BusWireT_SnapPosition(0, []);
    static Mid = new DrawModelType_BusWireT_SnapPosition(1, []);
    static Low = new DrawModelType_BusWireT_SnapPosition(2, []);
}

export function DrawModelType_BusWireT_SnapPosition_$reflection() {
    return union_type("DrawModelType.BusWireT.SnapPosition", [], DrawModelType_BusWireT_SnapPosition, () => [[], [], []]);
}

/**
 * Represents how wires are rendered
 */
export class DrawModelType_BusWireT_WireType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Radial", "Modern", "Jump"];
    }
    static Radial = new DrawModelType_BusWireT_WireType(0, []);
    static Modern = new DrawModelType_BusWireT_WireType(1, []);
    static Jump = new DrawModelType_BusWireT_WireType(2, []);
}

export function DrawModelType_BusWireT_WireType_$reflection() {
    return union_type("DrawModelType.BusWireT.WireType", [], DrawModelType_BusWireT_WireType, () => [[], [], []]);
}

/**
 * Used to represent a segment in a wire
 */
export class DrawModelType_BusWireT_Segment extends Record {
    constructor(Index, Length, WireId, IntersectOrJumpList, Draggable, Mode) {
        super();
        this.Index = (Index | 0);
        this.Length = Length;
        this.WireId = WireId;
        this.IntersectOrJumpList = IntersectOrJumpList;
        this.Draggable = Draggable;
        this.Mode = Mode;
    }
}

export function DrawModelType_BusWireT_Segment_$reflection() {
    return record_type("DrawModelType.BusWireT.Segment", [], DrawModelType_BusWireT_Segment, () => [["Index", int32_type], ["Length", float64_type], ["WireId", int32_type], ["IntersectOrJumpList", list_type(float64_type)], ["Draggable", bool_type], ["Mode", string_type]]);
}

/**
 * Add absolute vertices to a segment
 */
export class DrawModelType_BusWireT_ASegment extends Record {
    constructor(Start, End, Segment) {
        super();
        this.Start = Start;
        this.End = End;
        this.Segment = Segment;
    }
}

export function DrawModelType_BusWireT_ASegment_$reflection() {
    return record_type("DrawModelType.BusWireT.ASegment", [], DrawModelType_BusWireT_ASegment, () => [["Start", XYPos_$reflection()], ["End", XYPos_$reflection()], ["Segment", DrawModelType_BusWireT_Segment_$reflection()]]);
}

export class DrawModelType_BusWireT_Wire extends Record {
    constructor(WId, InputPort, OutputPort, Color, Width, Segments, StartPos, InitialOrientation) {
        super();
        this.WId = WId;
        this.InputPort = InputPort;
        this.OutputPort = OutputPort;
        this.Color = Color;
        this.Width = (Width | 0);
        this.Segments = Segments;
        this.StartPos = StartPos;
        this.InitialOrientation = InitialOrientation;
    }
}

export function DrawModelType_BusWireT_Wire_$reflection() {
    return record_type("DrawModelType.BusWireT.Wire", [], DrawModelType_BusWireT_Wire, () => [["WId", int32_type], ["InputPort", int32_type], ["OutputPort", int32_type], ["Color", HighLightColor_$reflection()], ["Width", int32_type], ["Segments", list_type(DrawModelType_BusWireT_Segment_$reflection())], ["StartPos", XYPos_$reflection()], ["InitialOrientation", string_type]]);
}

/**
 * Defines offsets used to render wire width text
 */
export class DrawModelType_BusWireT_TextOffset {
    constructor() {
    }
}

export function DrawModelType_BusWireT_TextOffset_$reflection() {
    return class_type("DrawModelType.BusWireT.TextOffset", undefined, DrawModelType_BusWireT_TextOffset);
}

export class DrawModelType_BusWireT_Model extends Record {
    constructor(Symbol$, Wires, CopiedWires, SelectedSegment, LastMousePos, ErrorWires, Notifications, Type, ArrowDisplay, SnapToNet) {
        super();
        this.Symbol = Symbol$;
        this.Wires = Wires;
        this.CopiedWires = CopiedWires;
        this.SelectedSegment = SelectedSegment;
        this.LastMousePos = LastMousePos;
        this.ErrorWires = ErrorWires;
        this.Notifications = Notifications;
        this.Type = Type;
        this.ArrowDisplay = ArrowDisplay;
        this.SnapToNet = SnapToNet;
    }
}

export function DrawModelType_BusWireT_Model_$reflection() {
    return record_type("DrawModelType.BusWireT.Model", [], DrawModelType_BusWireT_Model, () => [["Symbol", DrawModelType_SymbolT_Model_$reflection()], ["Wires", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [int32_type, DrawModelType_BusWireT_Wire_$reflection()])], ["CopiedWires", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [int32_type, DrawModelType_BusWireT_Wire_$reflection()])], ["SelectedSegment", list_type(tuple_type(int32_type, int32_type))], ["LastMousePos", XYPos_$reflection()], ["ErrorWires", list_type(int32_type)], ["Notifications", option_type(string_type)], ["Type", DrawModelType_BusWireT_WireType_$reflection()], ["ArrowDisplay", bool_type], ["SnapToNet", bool_type]]);
}

/**
 * BusWire messages: see BusWire.update for more info
 */
export class DrawModelType_BusWireT_Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Symbol", "AddWire", "BusWidths", "CopyWires", "DeleteWires", "DeleteWiresWithPort", "SelectWires", "UpdateWires", "UpdateSymbolWires", "DragSegment", "CoalesceWire", "ColorWires", "ErrorWires", "ResetJumps", "MakeJumps", "RerouteAllFloatingWires", "UpdateWireDisplayType", "ToggleArrowDisplay", "ResetModel", "LoadConnections", "UpdateConnectedWires", "RerouteWire", "ToggleSnapToNet"];
    }
    static BusWidths = new DrawModelType_BusWireT_Msg(2, []);
    static RerouteAllFloatingWires = new DrawModelType_BusWireT_Msg(15, []);
    static ToggleArrowDisplay = new DrawModelType_BusWireT_Msg(17, []);
    static ResetModel = new DrawModelType_BusWireT_Msg(18, []);
    static ToggleSnapToNet = new DrawModelType_BusWireT_Msg(22, []);
}

export function DrawModelType_BusWireT_Msg_$reflection() {
    return union_type("DrawModelType.BusWireT.Msg", [], DrawModelType_BusWireT_Msg, () => [[["Item", DrawModelType_SymbolT_Msg_$reflection()]], [["Item", tuple_type(int32_type, int32_type)]], [], [["Item", list_type(int32_type)]], [["Item", list_type(int32_type)]], [["Item", list_type(option_type(Port_$reflection()))]], [["Item", list_type(int32_type)]], [["Item1", list_type(int32_type)], ["Item2", XYPos_$reflection()]], [["Item", int32_type]], [["Item1", list_type(tuple_type(int32_type, int32_type))], ["Item2", MouseT_$reflection()]], [["Item", int32_type]], [["Item1", list_type(int32_type)], ["Item2", HighLightColor_$reflection()]], [["Item", list_type(int32_type)]], [["Item", list_type(int32_type)]], [["separate", bool_type], ["conns", list_type(int32_type)]], [], [["Item", DrawModelType_BusWireT_WireType_$reflection()]], [], [], [["Item", list_type(Connection_$reflection())]], [["Item", list_type(int32_type)]], [["Item", int32_type]], []]);
}

export const DrawModelType_BusWireT_segments_ = segments_$0040413$002D1.Value;

export const DrawModelType_BusWireT_mode_ = mode_$0040414$002D1.Value;

export function DrawModelType_BusWireT_TextOffset_get_yOffset() {
    return 7;
}

export function DrawModelType_BusWireT_TextOffset_get_xOffset() {
    return 1;
}

export function DrawModelType_BusWireT_TextOffset_get_xLeftOffset() {
    return 20;
}

export const DrawModelType_BusWireT_symbol_ = symbol_$0040470$002D1.Value;

export const DrawModelType_BusWireT_wires_ = wires_$0040471$002D1.Value;

export function DrawModelType_BusWireT_wireOf_(k) {
    let k_1;
    const l = wires_$0040471$002D1.Value;
    return Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, (k_1 = k, [(arg_1) => {
        const _arg = tryFind(k_1, arg_1);
        return (_arg == null) ? toFail(printf("%s"))("What? Symbol id lookup in model failed") : _arg;
    }, (v_1) => ((x) => add(k_1, v_1, x))]))(l);
}

export function DrawModelType_BusWireT_symbolOf_(k) {
    const l = symbol_$0040470$002D1.Value;
    return Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SymbolT_symbolOf_(k))(l);
}

export class DrawModelType_SheetT_ScalingBox extends Record {
    constructor(ScaleButton, RotateDeg90Button, RotateDeg270Button, ScalingBoxBound, ButtonList) {
        super();
        this.ScaleButton = ScaleButton;
        this.RotateDeg90Button = RotateDeg90Button;
        this.RotateDeg270Button = RotateDeg270Button;
        this.ScalingBoxBound = ScalingBoxBound;
        this.ButtonList = ButtonList;
    }
}

export function DrawModelType_SheetT_ScalingBox_$reflection() {
    return record_type("DrawModelType.SheetT.ScalingBox", [], DrawModelType_SheetT_ScalingBox, () => [["ScaleButton", DrawModelType_SymbolT_Symbol_$reflection()], ["RotateDeg90Button", DrawModelType_SymbolT_Symbol_$reflection()], ["RotateDeg270Button", DrawModelType_SymbolT_Symbol_$reflection()], ["ScalingBoxBound", BoundingBox_$reflection()], ["ButtonList", list_type(int32_type)]]);
}

/**
 * Used to keep mouse movement (AKA velocity) info as well as position
 */
export class DrawModelType_SheetT_XYPosMov extends Record {
    constructor(Pos, Move) {
        super();
        this.Pos = Pos;
        this.Move = Move;
    }
}

export function DrawModelType_SheetT_XYPosMov_$reflection() {
    return record_type("DrawModelType.SheetT.XYPosMov", [], DrawModelType_SheetT_XYPosMov, () => [["Pos", XYPos_$reflection()], ["Move", XYPos_$reflection()]]);
}

/**
 * Used to keep track of what the mouse is on
 */
export class DrawModelType_SheetT_MouseOn extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Label", "InputPort", "OutputPort", "Component", "Connection", "ComponentCorner", "Canvas"];
    }
    static Canvas = new DrawModelType_SheetT_MouseOn(6, []);
}

export function DrawModelType_SheetT_MouseOn_$reflection() {
    return union_type("DrawModelType.SheetT.MouseOn", [], DrawModelType_SheetT_MouseOn, () => [[["Item", int32_type]], [["Item1", int32_type], ["Item2", XYPos_$reflection()]], [["Item1", int32_type], ["Item2", XYPos_$reflection()]], [["Item", int32_type]], [["Item", int32_type]], [["Item1", int32_type], ["Item2", XYPos_$reflection()], ["Item3", int32_type]], []]);
}

/**
 * What a right-click has made draggable on one custom component.
 * 
 * These used to be reached by holding Ctrl, which meant the affordance appeared on every
 * custom component at once, vanished if the key was released or the window lost focus, and
 * was undiscoverable. A mode entered from the component's own menu applies to that component
 * alone and stays until the user clicks away.
 */
export class DrawModelType_SheetT_SymbolEditMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["EditPorts", "EditSize"];
    }
    static EditPorts = new DrawModelType_SheetT_SymbolEditMode(0, []);
    static EditSize = new DrawModelType_SheetT_SymbolEditMode(1, []);
}

export function DrawModelType_SheetT_SymbolEditMode_$reflection() {
    return union_type("DrawModelType.SheetT.SymbolEditMode", [], DrawModelType_SheetT_SymbolEditMode, () => [[], []]);
}

/**
 * Keeps track of the current action that the user is doing
 */
export class DrawModelType_SheetT_CurrentAction extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Selecting", "InitialiseMoving", "InitialiseMovingLabel", "MovingSymbols", "MovingLabel", "DragAndDrop", "Panning", "MovingWire", "ConnectingInput", "ConnectingOutput", "Scrolling", "Idle", "Scaling", "InitialisedCreateComponent", "MovingPort", "ResizingSymbol"];
    }
    static Selecting = new DrawModelType_SheetT_CurrentAction(0, []);
    static MovingSymbols = new DrawModelType_SheetT_CurrentAction(3, []);
    static MovingLabel = new DrawModelType_SheetT_CurrentAction(4, []);
    static DragAndDrop = new DrawModelType_SheetT_CurrentAction(5, []);
    static Scrolling = new DrawModelType_SheetT_CurrentAction(10, []);
    static Idle = new DrawModelType_SheetT_CurrentAction(11, []);
    static Scaling = new DrawModelType_SheetT_CurrentAction(12, []);
}

export function DrawModelType_SheetT_CurrentAction_$reflection() {
    return union_type("DrawModelType.SheetT.CurrentAction", [], DrawModelType_SheetT_CurrentAction, () => [[], [["Item", int32_type]], [["Item", int32_type]], [], [], [], [["offset", XYPos_$reflection()]], [["Item", list_type(tuple_type(int32_type, int32_type))]], [["Item", int32_type]], [["Item", int32_type]], [], [], [], [["Item1", list_type(LoadedComponent_$reflection())], ["Item2", ComponentType_$reflection()], ["Item3", string_type], ["Item4", option_type(lambda_type(int32_type, unit_type))]], [["portId", int32_type]], [["Item1", int32_type], ["Item2", XYPos_$reflection()]]]);
}

export class DrawModelType_SheetT_UndoAction extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["MoveBackSymbol", "UndoPaste"];
    }
}

export function DrawModelType_SheetT_UndoAction_$reflection() {
    return union_type("DrawModelType.SheetT.UndoAction", [], DrawModelType_SheetT_UndoAction, () => [[["Item1", list_type(int32_type)], ["Item2", XYPos_$reflection()]], [["Item", list_type(int32_type)]]]);
}

/**
 * For Keyboard messages.
 * These name draw block *actions*, not keys - KeyTypes decides which chord reaches which.
 * AltC, AltV, AltZ and AltShiftZ used to be here with no dispatcher, and CtrlS with a handler
 * that added a square for a demo.
 */
export class DrawModelType_SheetT_KeyboardMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CtrlC", "CtrlV", "CtrlZ", "CtrlY", "CtrlA", "CtrlW", "ZoomIn", "ZoomOut", "DEL", "ESC"];
    }
    static CtrlC = new DrawModelType_SheetT_KeyboardMsg(0, []);
    static CtrlV = new DrawModelType_SheetT_KeyboardMsg(1, []);
    static CtrlZ = new DrawModelType_SheetT_KeyboardMsg(2, []);
    static CtrlY = new DrawModelType_SheetT_KeyboardMsg(3, []);
    static CtrlA = new DrawModelType_SheetT_KeyboardMsg(4, []);
    static CtrlW = new DrawModelType_SheetT_KeyboardMsg(5, []);
    static ZoomIn = new DrawModelType_SheetT_KeyboardMsg(6, []);
    static ZoomOut = new DrawModelType_SheetT_KeyboardMsg(7, []);
    static DEL = new DrawModelType_SheetT_KeyboardMsg(8, []);
    static ESC = new DrawModelType_SheetT_KeyboardMsg(9, []);
}

export function DrawModelType_SheetT_KeyboardMsg_$reflection() {
    return union_type("DrawModelType.SheetT.KeyboardMsg", [], DrawModelType_SheetT_KeyboardMsg, () => [[], [], [], [], [], [], [], [], [], []]);
}

export class DrawModelType_SheetT_WireTypeMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Jump", "Radiussed", "Modern"];
    }
    static Jump = new DrawModelType_SheetT_WireTypeMsg(0, []);
    static Radiussed = new DrawModelType_SheetT_WireTypeMsg(1, []);
    static Modern = new DrawModelType_SheetT_WireTypeMsg(2, []);
}

export function DrawModelType_SheetT_WireTypeMsg_$reflection() {
    return union_type("DrawModelType.SheetT.WireTypeMsg", [], DrawModelType_SheetT_WireTypeMsg, () => [[], [], []]);
}

export class DrawModelType_SheetT_IssieInterfaceMsg extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["ToggleArrows"];
    }
    static ToggleArrows = new DrawModelType_SheetT_IssieInterfaceMsg();
}

export function DrawModelType_SheetT_IssieInterfaceMsg_$reflection() {
    return union_type("DrawModelType.SheetT.IssieInterfaceMsg", [], DrawModelType_SheetT_IssieInterfaceMsg, () => [[]]);
}

/**
 * Possible fields that may (or may not) be used in a dialog popup.
 */
export class DrawModelType_SheetT_PopupDialogData extends Record {
    constructor(Text$, Int, Int2) {
        super();
        this.Text = Text$;
        this.Int = Int;
        this.Int2 = Int2;
    }
}

export function DrawModelType_SheetT_PopupDialogData_$reflection() {
    return record_type("DrawModelType.SheetT.PopupDialogData", [], DrawModelType_SheetT_PopupDialogData, () => [["Text", option_type(string_type)], ["Int", option_type(int32_type)], ["Int2", option_type(bigint_type)]]);
}

export class DrawModelType_SheetT_Arrange extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AlignSymbols", "DistributeSymbols"];
    }
    static AlignSymbols = new DrawModelType_SheetT_Arrange(0, []);
    static DistributeSymbols = new DrawModelType_SheetT_Arrange(1, []);
}

export function DrawModelType_SheetT_Arrange_$reflection() {
    return union_type("DrawModelType.SheetT.Arrange", [], DrawModelType_SheetT_Arrange, () => [[], []]);
}

/**
 * Which way the copies of a pasted array run. A fragment is arrayed across its short axis, so
 * that the copies stack up beside each other rather than end to end: a row of gates laid out
 * left to right becomes a vertical array, and a column of them a horizontal one.
 * 
 * Prefixed because CommonTypes.Orientation is Horizontal | Vertical and is used unqualified
 * all over the draw block - two of these cases named the same would shadow it.
 */
export class DrawModelType_SheetT_ArrayDirection extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ArrayVertical", "ArrayHorizontal"];
    }
    static ArrayVertical = new DrawModelType_SheetT_ArrayDirection(0, []);
    static ArrayHorizontal = new DrawModelType_SheetT_ArrayDirection(1, []);
}

export function DrawModelType_SheetT_ArrayDirection_$reflection() {
    return union_type("DrawModelType.SheetT.ArrayDirection", [], DrawModelType_SheetT_ArrayDirection, () => [[], []]);
}

export class DrawModelType_SheetT_CompilationStage extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Completed", "InProgress", "Failed", "Queued"];
    }
    static Failed = new DrawModelType_SheetT_CompilationStage(2, []);
    static Queued = new DrawModelType_SheetT_CompilationStage(3, []);
}

export function DrawModelType_SheetT_CompilationStage_$reflection() {
    return union_type("DrawModelType.SheetT.CompilationStage", [], DrawModelType_SheetT_CompilationStage, () => [[["Item", int32_type]], [["Item", int32_type]], [], []]);
}

export class DrawModelType_SheetT_CompilationStageLabel extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Synthesis", "PlaceAndRoute", "Generate", "Upload"];
    }
    static Synthesis = new DrawModelType_SheetT_CompilationStageLabel(0, []);
    static PlaceAndRoute = new DrawModelType_SheetT_CompilationStageLabel(1, []);
    static Generate = new DrawModelType_SheetT_CompilationStageLabel(2, []);
    static Upload = new DrawModelType_SheetT_CompilationStageLabel(3, []);
}

export function DrawModelType_SheetT_CompilationStageLabel_$reflection() {
    return union_type("DrawModelType.SheetT.CompilationStageLabel", [], DrawModelType_SheetT_CompilationStageLabel, () => [[], [], [], []]);
}

export class DrawModelType_SheetT_CompileStatus extends Record {
    constructor(Synthesis, PlaceAndRoute, Generate, Upload) {
        super();
        this.Synthesis = Synthesis;
        this.PlaceAndRoute = PlaceAndRoute;
        this.Generate = Generate;
        this.Upload = Upload;
    }
}

export function DrawModelType_SheetT_CompileStatus_$reflection() {
    return record_type("DrawModelType.SheetT.CompileStatus", [], DrawModelType_SheetT_CompileStatus, () => [["Synthesis", DrawModelType_SheetT_CompilationStage_$reflection()], ["PlaceAndRoute", DrawModelType_SheetT_CompilationStage_$reflection()], ["Generate", DrawModelType_SheetT_CompilationStage_$reflection()], ["Upload", DrawModelType_SheetT_CompilationStage_$reflection()]]);
}

export class DrawModelType_SheetT_Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Wire", "SetWireModel", "KeyPress", "ToggleGrid", "KeepZoomCentered", "ApplyPendingZoomCenter", "PreciseZoom", "MouseMsg", "MouseMsgOrig", "UpdateBoundingBoxes", "UpdateSingleBoundingBox", "UpdateScrollPos", "UpdateScrollPosFromCanvas", "AddNotConnected", "CheckAutomaticScrolling", "DoNothing", "ShowPopup", "ClosePopup", "SetPopupDialogText", "SetPopupDialogInt", "InitialiseCreateComponent", "FlushCommandStack", "ResetModel", "UpdateSelectedWires", "ColourSelection", "PortMovementStart", "PortMovementEnd", "PanModeStart", "PanModeEnd", "ResetSelection", "ToggleNet", "SelectWires", "SelectComponents", "SetSpinner", "Rotate", "Flip", "Arrangement", "PasteArray", "RotateLabels", "RedrawWires", "SeparateManualRouting", "WireType", "IssieInterface", "MovePort", "SaveSymbols", "StartCompiling", "StartCompilationStage", "StopCompilation", "TickCompilation", "FinishedCompilationStage", "DebugSingleStep", "DebugStepAndRead", "DebugRead", "OnDebugRead", "DebugConnect", "DebugDisconnect", "DebugUpdateMapping", "DebugContinue", "DebugPause", "SetDebugDevice", "ReorderPorts", "TestSmartChannel", "TestPortPosition", "ToggleSnapToNet", "BeautifySheet", "SheetBatch", "ExecFuncInSheetMessage"];
    }
    static ToggleGrid = new DrawModelType_SheetT_Msg(3, []);
    static ApplyPendingZoomCenter = new DrawModelType_SheetT_Msg(5, []);
    static UpdateBoundingBoxes = new DrawModelType_SheetT_Msg(9, []);
    static CheckAutomaticScrolling = new DrawModelType_SheetT_Msg(14, []);
    static DoNothing = new DrawModelType_SheetT_Msg(15, []);
    static ClosePopup = new DrawModelType_SheetT_Msg(17, []);
    static FlushCommandStack = new DrawModelType_SheetT_Msg(21, []);
    static ResetModel = new DrawModelType_SheetT_Msg(22, []);
    static PortMovementStart = new DrawModelType_SheetT_Msg(25, []);
    static PortMovementEnd = new DrawModelType_SheetT_Msg(26, []);
    static PanModeStart = new DrawModelType_SheetT_Msg(27, []);
    static PanModeEnd = new DrawModelType_SheetT_Msg(28, []);
    static ResetSelection = new DrawModelType_SheetT_Msg(29, []);
    static RotateLabels = new DrawModelType_SheetT_Msg(38, []);
    static SeparateManualRouting = new DrawModelType_SheetT_Msg(40, []);
    static SaveSymbols = new DrawModelType_SheetT_Msg(44, []);
    static StopCompilation = new DrawModelType_SheetT_Msg(47, []);
    static FinishedCompilationStage = new DrawModelType_SheetT_Msg(49, []);
    static DebugSingleStep = new DrawModelType_SheetT_Msg(50, []);
    static DebugConnect = new DrawModelType_SheetT_Msg(54, []);
    static DebugDisconnect = new DrawModelType_SheetT_Msg(55, []);
    static DebugContinue = new DrawModelType_SheetT_Msg(57, []);
    static DebugPause = new DrawModelType_SheetT_Msg(58, []);
    static ReorderPorts = new DrawModelType_SheetT_Msg(60, []);
    static TestSmartChannel = new DrawModelType_SheetT_Msg(61, []);
    static TestPortPosition = new DrawModelType_SheetT_Msg(62, []);
    static ToggleSnapToNet = new DrawModelType_SheetT_Msg(63, []);
    static BeautifySheet = new DrawModelType_SheetT_Msg(64, []);
}

export function DrawModelType_SheetT_Msg_$reflection() {
    return union_type("DrawModelType.SheetT.Msg", [], DrawModelType_SheetT_Msg, () => [[["Item", DrawModelType_BusWireT_Msg_$reflection()]], [["Item", DrawModelType_BusWireT_Model_$reflection()]], [["Item", DrawModelType_SheetT_KeyboardMsg_$reflection()]], [], [["Item", XYPos_$reflection()]], [], [["Item", float64_type]], [["Item", MouseT_$reflection()]], [["Item1", class_type("Browser.Types.MouseEvent", undefined)], ["Item2", MouseOp_$reflection()], ["Item3", float64_type]], [], [["Item", int32_type]], [["Item", XYPos_$reflection()]], [["Item", XYPos_$reflection()]], [["Item1", list_type(LoadedComponent_$reflection())], ["port", Port_$reflection()], ["pos", XYPos_$reflection()], ["rotation", Rotation_$reflection()]], [], [], [["Item", lambda_type(lambda_type(DrawModelType_SheetT_Msg_$reflection(), unit_type), lambda_type(DrawModelType_SheetT_PopupDialogData_$reflection(), class_type("Fable.React.ReactElement", undefined)))]], [], [["Item", option_type(string_type)]], [["Item", option_type(int32_type)]], [["Item1", list_type(LoadedComponent_$reflection())], ["Item2", ComponentType_$reflection()], ["Item3", string_type], ["Item4", option_type(lambda_type(int32_type, unit_type))]], [], [], [["Item1", list_type(int32_type)], ["Item2", bool_type]], [["compIds", list_type(int32_type)], ["connIds", list_type(int32_type)], ["colour", HighLightColor_$reflection()]], [], [], [], [], [], [["Item", tuple_type(list_type(Component_$reflection()), list_type(Connection_$reflection()))]], [["Item", list_type(int32_type)]], [["Item", list_type(int32_type)]], [["Item", bool_type]], [["Item", Rotation_$reflection()]], [["Item", string_type]], [["Item", DrawModelType_SheetT_Arrange_$reflection()]], [["direction", DrawModelType_SheetT_ArrayDirection_$reflection()], ["copies", int32_type], ["firstSuffix", int32_type]], [], [["manualToo", bool_type]], [], [["Item", DrawModelType_SheetT_WireTypeMsg_$reflection()]], [["Item", DrawModelType_SheetT_IssieInterfaceMsg_$reflection()]], [["Item", MouseT_$reflection()]], [], [["path", string_type], ["name", string_type], ["profile", CompilationProfile_$reflection()]], [["Item1", DrawModelType_SheetT_CompilationStageLabel_$reflection()], ["path", string_type], ["name", string_type], ["profile", CompilationProfile_$reflection()]], [], [["Item", string_type]], [], [], [["parts", int32_type]], [["parts", int32_type]], [["data", int32_type], ["viewer", int32_type]], [], [], [["Item", array_type(string_type)]], [], [], [["Item", string_type]], [], [], [], [], [], [["Item", list_type(DrawModelType_SheetT_Msg_$reflection())]], [["Item", lambda_type(DrawModelType_SheetT_Model_$reflection(), unit_type)]]]);
}

export class DrawModelType_SheetT_ReadLog extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["ReadLog"];
    }
}

export function DrawModelType_SheetT_ReadLog_$reflection() {
    return union_type("DrawModelType.SheetT.ReadLog", [], DrawModelType_SheetT_ReadLog, () => [[["Item", int32_type]]]);
}

export class DrawModelType_SheetT_DebugState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotDebugging", "Paused", "Running"];
    }
    static NotDebugging = new DrawModelType_SheetT_DebugState(0, []);
    static Paused = new DrawModelType_SheetT_DebugState(1, []);
    static Running = new DrawModelType_SheetT_DebugState(2, []);
}

export function DrawModelType_SheetT_DebugState_$reflection() {
    return union_type("DrawModelType.SheetT.DebugState", [], DrawModelType_SheetT_DebugState, () => [[], [], []]);
}

export class DrawModelType_SheetT_ScalingDirection extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ScaleUp", "ScaleDown"];
    }
    static ScaleUp = new DrawModelType_SheetT_ScalingDirection(0, []);
    static ScaleDown = new DrawModelType_SheetT_ScalingDirection(1, []);
}

export function DrawModelType_SheetT_ScalingDirection_$reflection() {
    return union_type("DrawModelType.SheetT.ScalingDirection", [], DrawModelType_SheetT_ScalingDirection, () => [[], []]);
}

export class DrawModelType_SheetT_Model extends Record {
    constructor(Wire, PopupViewFunc, PopupDialogData, BoundingBoxes, LastValidBoundingBoxes, SelectedLabel, SelectedComponents, SelectedWires, NearbyComponents, HoveredWire, ErrorComponents, DragToSelectBox, ConnectPortsLine, TargetPortId, Action, ShowGrid, CursorType, LastCursorType, LastValidPos, LastValidSymbol, SymbolEdit, SnapSymbols, SnapSegments, Zoom, CanvasSize, TmpModel, ScalingTmpModel, UndoList, RedoList, AutomaticScrolling, ScreenScrollPos, PendingZoomCenter, LastMousePos, ScalingBoxCentrePos, InitMouseToScalingBoxCentre, ScrollingLastMousePos, LastMousePosForSnap, MouseCounter, CtrlKeyDown, SpaceKeyDown, PrevWireSelection, OfferPasteArray, ScalingBox, Compiling, CompilationStatus, CompilationJob, DebugState, DebugData, DebugMappings, DebugIsConnected, DebugDevice) {
        super();
        this.Wire = Wire;
        this.PopupViewFunc = PopupViewFunc;
        this.PopupDialogData = PopupDialogData;
        this.BoundingBoxes = BoundingBoxes;
        this.LastValidBoundingBoxes = LastValidBoundingBoxes;
        this.SelectedLabel = SelectedLabel;
        this.SelectedComponents = SelectedComponents;
        this.SelectedWires = SelectedWires;
        this.NearbyComponents = NearbyComponents;
        this.HoveredWire = HoveredWire;
        this.ErrorComponents = ErrorComponents;
        this.DragToSelectBox = DragToSelectBox;
        this.ConnectPortsLine = ConnectPortsLine;
        this.TargetPortId = TargetPortId;
        this.Action = Action;
        this.ShowGrid = ShowGrid;
        this.CursorType = CursorType;
        this.LastCursorType = LastCursorType;
        this.LastValidPos = LastValidPos;
        this.LastValidSymbol = LastValidSymbol;
        this.SymbolEdit = SymbolEdit;
        this.SnapSymbols = SnapSymbols;
        this.SnapSegments = SnapSegments;
        this.Zoom = Zoom;
        this.CanvasSize = CanvasSize;
        this.TmpModel = TmpModel;
        this.ScalingTmpModel = ScalingTmpModel;
        this.UndoList = UndoList;
        this.RedoList = RedoList;
        this.AutomaticScrolling = AutomaticScrolling;
        this.ScreenScrollPos = ScreenScrollPos;
        this.PendingZoomCenter = PendingZoomCenter;
        this.LastMousePos = LastMousePos;
        this.ScalingBoxCentrePos = ScalingBoxCentrePos;
        this.InitMouseToScalingBoxCentre = InitMouseToScalingBoxCentre;
        this.ScrollingLastMousePos = ScrollingLastMousePos;
        this.LastMousePosForSnap = LastMousePosForSnap;
        this.MouseCounter = (MouseCounter | 0);
        this.CtrlKeyDown = CtrlKeyDown;
        this.SpaceKeyDown = SpaceKeyDown;
        this.PrevWireSelection = PrevWireSelection;
        this.OfferPasteArray = OfferPasteArray;
        this.ScalingBox = ScalingBox;
        this.Compiling = Compiling;
        this.CompilationStatus = CompilationStatus;
        this.CompilationJob = CompilationJob;
        this.DebugState = DebugState;
        this.DebugData = DebugData;
        this.DebugMappings = DebugMappings;
        this.DebugIsConnected = DebugIsConnected;
        this.DebugDevice = DebugDevice;
    }
}

export function DrawModelType_SheetT_Model_$reflection() {
    return record_type("DrawModelType.SheetT.Model", [], DrawModelType_SheetT_Model, () => [["Wire", DrawModelType_BusWireT_Model_$reflection()], ["PopupViewFunc", option_type(lambda_type(lambda_type(DrawModelType_SheetT_Msg_$reflection(), unit_type), lambda_type(DrawModelType_SheetT_PopupDialogData_$reflection(), class_type("Fable.React.ReactElement", undefined))))], ["PopupDialogData", DrawModelType_SheetT_PopupDialogData_$reflection()], ["BoundingBoxes", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [int32_type, BoundingBox_$reflection()])], ["LastValidBoundingBoxes", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [int32_type, BoundingBox_$reflection()])], ["SelectedLabel", option_type(int32_type)], ["SelectedComponents", list_type(int32_type)], ["SelectedWires", list_type(int32_type)], ["NearbyComponents", list_type(int32_type)], ["HoveredWire", option_type(int32_type)], ["ErrorComponents", list_type(int32_type)], ["DragToSelectBox", BoundingBox_$reflection()], ["ConnectPortsLine", tuple_type(XYPos_$reflection(), XYPos_$reflection())], ["TargetPortId", int32_type], ["Action", DrawModelType_SheetT_CurrentAction_$reflection()], ["ShowGrid", bool_type], ["CursorType", CursorType_$reflection()], ["LastCursorType", CursorType_$reflection()], ["LastValidPos", XYPos_$reflection()], ["LastValidSymbol", option_type(DrawModelType_SymbolT_Symbol_$reflection())], ["SymbolEdit", option_type(tuple_type(int32_type, DrawModelType_SheetT_SymbolEditMode_$reflection()))], ["SnapSymbols", DrawModelType_SnapXY_$reflection()], ["SnapSegments", DrawModelType_SnapXY_$reflection()], ["Zoom", float64_type], ["CanvasSize", float64_type], ["TmpModel", option_type(DrawModelType_SheetT_Model_$reflection())], ["ScalingTmpModel", option_type(DrawModelType_SheetT_Model_$reflection())], ["UndoList", list_type(DrawModelType_SheetT_Model_$reflection())], ["RedoList", list_type(DrawModelType_SheetT_Model_$reflection())], ["AutomaticScrolling", bool_type], ["ScreenScrollPos", XYPos_$reflection()], ["PendingZoomCenter", option_type(XYPos_$reflection())], ["LastMousePos", XYPos_$reflection()], ["ScalingBoxCentrePos", XYPos_$reflection()], ["InitMouseToScalingBoxCentre", XYPos_$reflection()], ["ScrollingLastMousePos", DrawModelType_SheetT_XYPosMov_$reflection()], ["LastMousePosForSnap", XYPos_$reflection()], ["MouseCounter", int32_type], ["CtrlKeyDown", bool_type], ["SpaceKeyDown", bool_type], ["PrevWireSelection", list_type(int32_type)], ["OfferPasteArray", bool_type], ["ScalingBox", option_type(DrawModelType_SheetT_ScalingBox_$reflection())], ["Compiling", bool_type], ["CompilationStatus", DrawModelType_SheetT_CompileStatus_$reflection()], ["CompilationJob", option_type(string_type)], ["DebugState", DrawModelType_SheetT_DebugState_$reflection()], ["DebugData", list_type(int32_type)], ["DebugMappings", array_type(string_type)], ["DebugIsConnected", bool_type], ["DebugDevice", option_type(string_type)]]);
}

export const DrawModelType_SheetT_move_ = move_$0040495$002D1.Value;

export const DrawModelType_SheetT_pos_ = pos_$0040496$002D1.Value;

export const DrawModelType_SheetT_wire_ = wire_$0040782$002D1.Value;

export const DrawModelType_SheetT_selectedComponents_ = selectedComponents_$0040783$002D1.Value;

export const DrawModelType_SheetT_selectedWires_ = selectedWires_$0040784$002D1.Value;

export const DrawModelType_SheetT_boundingBoxes_ = boundingBoxes_$0040785$002D1.Value;

export const DrawModelType_SheetT_wires_ = wires_$0040789$002D3.Value;

export function DrawModelType_SheetT_wireOf_(k) {
    let k_1;
    const l = wires_$0040789$002D3.Value;
    return Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, (k_1 = k, [(arg_1) => {
        const _arg = tryFind(k_1, arg_1);
        return (_arg == null) ? toFail(printf("%s"))("What? Wire id lookup in model failed") : _arg;
    }, (v_1) => ((x) => add(k_1, v_1, x))]))(l);
}

export const DrawModelType_SheetT_symbol_ = symbol_$0040791$002D3.Value;

export const DrawModelType_SheetT_symbols_ = symbols_$0040792$002D3.Value;

export function DrawModelType_SheetT_symbolOf_(k) {
    const l = symbol_$0040791$002D3.Value;
    return Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SymbolT_symbolOf_(k))(l);
}

export const DrawModelType_SheetT_scrollingLastMousePos_ = scrollingLastMousePos_$0040794$002D1.Value;

export const DrawModelType_SheetT_lastMousePos_ = lastMousePos_$0040795$002D1.Value;

export const DrawModelType_SheetT_screenScrollPos_ = screenScrollPos_$0040796$002D1.Value;

export const DrawModelType_SheetT_lastMousePosForSnap_ = lastMousePosForSnap_$0040797$002D1.Value;

export const DrawModelType_SheetT_canvasSize_ = canvasSize_$0040798$002D1.Value;

export const DrawModelType_SheetT_zoom_ = zoom_$0040800$002D1.Value;

export const DrawModelType_SheetT_scalingBox_ = scalingBox_$0040802$002D1.Value;

export const DrawModelType_SheetT_symbolEdit_ = symbolEdit_$0040803$002D1.Value;

